import { EmailTemplate } from "./baseTemplate";
import { TemplateName, TemplateVariable } from "./types";
export class DefaultTemplate extends EmailTemplate {
    constructor() {
        super(...arguments);
        this.id = TemplateName.Default;
    }
    subject({ communication }) {
        return "An Email from Encamp";
    }
    extractVariables({ communication }) {
        return {
            [TemplateVariable.FacilityNames]: communication.facilities
                .map((f) => this.identifierSection(f))
                .join("<br /><br />"),
            [TemplateVariable.CompanyName]: communication.tenant.name,
        };
    }
    rawTemplate() {
        return this.baseHtml({
            identifierSection: `{{${TemplateVariable.FacilityNames}}}`,
            companyName: `{{${TemplateVariable.CompanyName}}}`,
            isRevision: false,
        });
    }
    html({ communication }) {
        const variables = this.extractVariables({ communication });
        return this.baseHtml({
            identifierSection: variables[TemplateVariable.FacilityNames],
            companyName: variables[TemplateVariable.CompanyName],
            isRevision: false,
        });
    }
}
//# sourceMappingURL=defaultTemplate.js.map